import React, { useContext, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { getGymGeneralStats, getGymOwnerClimbers, getGymOwnerRouteSetters, getRouteSetterGymFilterInfo, getSectorDetails, getSectorDetailsById, getSectorsOverview, ipAdress, loginUser } from '../data/getAxiosRequests';
import { useLocation, useNavigate } from 'react-router-dom';
import { csrftoken, formatDate, getDaysDifferenceMessage, getGradeFromIndex } from '../constants/helpers';
import IconButton from '../components/UI/IconButton';
import { SVGs } from '../constants/Svgs';
import CustomButton from '../components/UI/CustomButton';
import { httpToUse,  localIpAdress, portToUse } from '../data/getAxiosRequests';
import NavBarBackOffice from '../components/backOffice/Navbar';
import { DifficultySplit, GymExtraMinimalProps, GymMinimalProps, GymStats, PotentialNewRouteSetter, RouteSetterProps, RouteSetters, SectorBasisChoices, SectorCategory, SectorDetailsProps, SectorsOverview } from '../constants/types';
import { GlobalContext } from '../context/GlobalStateProvider';
import Modal from '../components/UI/ModalRoute';
import { Colors, pages } from '../constants/Consts';
import StatBox from '../components/backOffice/StatBox';
import DifficultySummaryHome from '../components/HomePage/DifficultySummaryHome';
import SectorSummaryRow from '../components/backOffice/SectorSummaryRow';
import SectorItem from '../components/UI/SectorItem';
import StatBoxSector from '../components/backOffice/StatBoxSector';
import StatisticRow from '../components/backOffice/StatisticRow';
import StarRating from '../components/UI/StarRating';
import DifficultySplitComponent from '../components/UI/DifficultySplit';
import SectorDetailsRow, { SectorDetailsRowProps } from '../components/backOffice/SectorDetailsRow';
import CommentsCard from '../components/backOffice/CommentsCard';
import CustomButtonBO from '../components/UI/CustomButtonBO';
import ParameterRouteSetterRow, { rolesConst } from '../components/backOffice/ParametersRouteSetterRow';
import Select from 'react-select';





const SkeletonBlock: React.FC<{ className?: string }> = ({ className = '' }) => (
    <div className={`bg-grey-200 rounded-lg animate-pulse ${className}`} />
);

const ParametersPageSkeleton: React.FC = () => (
    <>
        {/* Profil section skeleton */}
        <div className="pannels-filter__filters">
            <SkeletonBlock className="h-6 w-32" />
            <SkeletonBlock className="h-4 w-96 mt-1" />
            <SkeletonBlock className="h-10 w-64 mt-2 rounded-md" />
        </div>

        {/* Mes ouvreurs section skeleton */}
        <div className="pannels-filter__filters">
            <div className="flex flex-row justify-between w-full">
                <SkeletonBlock className="h-6 w-40" />
                <SkeletonBlock className="h-9 w-44 rounded-md" />
            </div>
            <div className="flex flex-col gap-2 mt-2 w-full">
                <SkeletonBlock className="h-8 w-full rounded-md" />
                <SkeletonBlock className="h-14 w-full rounded-md" />
                <SkeletonBlock className="h-14 w-full rounded-md" />
                <SkeletonBlock className="h-14 w-full rounded-md" />
            </div>
        </div>
    </>
);

const ParametersPage: React.FC = () => {
    const navigate  = useNavigate()
    
    const globalContext = useContext(GlobalContext);
    const [shouldBeLoading, setShouldBeLoading] = useState(true)
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [openChangePassword, setOpenChangePassword] = useState(false)
    const toggleOpenChangePassword = () => {
        setOpenChangePassword(prev => !prev); // Toggle the state of extendedRow
    };
    const [gymRouteSetters, setGymRouteSetters] = useState<RouteSetters[]>([]);
    const [listOfGyms, setListOfGyms] = useState<GymExtraMinimalProps[]>([]);
    const [addRouteSetter, setAddRouteSetter] = useState(false)
    const [chooseGymForNewRouteSetter, setChooseGymForNewRouteSetter] = useState(false)

    const [potentialNewRouteSetters, setPotentialNewRouteSetters] = useState<PotentialNewRouteSetter[]>([]);
    const [selectedPotentialRouteSetter, setSelectedPotentialRouteSetter] = useState(null);
    


    const { currentGym, setCurrentGym,setCurrentPage,currentPage,setGymsFilterInfo,gymsFilterInfo,user,setUser,routeSetterInfo, setRouteSetterInfo } = globalContext;

    const toggleChangeAddRouteSetter = () => {
        setAddRouteSetter(prev => !prev); // Toggle the state of extendedRow
    };

    const toggleChooseGymForNewRouteSetter = () => {
        setChooseGymForNewRouteSetter(prev => !prev); // Toggle the state of extendedRow
        
    };

    useEffect(() => {
        document.title = "Paramètres"
    },[])

    const [selectedGyms, setSelectedGyms] = useState<GymExtraMinimalProps[]>([]);

    useEffect(() => {
        if (!currentGym) {
            const favoriteGym = localStorage.getItem('favoriteGymInfo');
            setCurrentGym(JSON.parse(favoriteGym))
        }
        if (!user) {
            const loggedUser = localStorage.getItem('user');
            if (loggedUser) {
                setUser(JSON.parse(loggedUser));
            } else {
                navigate('/login-pro');
            }
        }
    }, []);

    useEffect(() => {
        setCurrentPage(pages.parameters)
    }, []);

    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordConfirmationShown, setPasswordConfirmationShown] = useState(false);
    
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    const togglePasswordConfirmationVisibility = () => {
        setPasswordConfirmationShown(!passwordConfirmationShown);
    };

    const formik = useFormik({
        initialValues: {
            newPassword: '',
            confirmPassword: ''
        },
        validationSchema: Yup.object({
            newPassword: Yup.string()
            .min(8, 'Le mot de passe doit contenir au moins 8 caractères')
            .matches(/[A-Z]/, 'Le mot de passe doit contenir au moins une majuscule')
            .matches(/[0-9]/, 'le mot de passe doit contenir au moins un chiffre')
            .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Le mot de passe doit contenir au moins un caractère spécial')
            .required('Le mot de passe est requis'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], "La confirmation du mot de passe n'est pas identique")
                .required('La confirmation du mot de passe est requise')
        }),
        onSubmit: async (values) => {
            try {
                axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
                const response = await axios.post(`https://rotpunkttest.fr/api/change-password-admin/${user}/`, {
                    new_password: values.newPassword,
                    confirm_password: values.confirmPassword
                });
        
                if (response.status === 200) {
                    navigate('/password-changed/')
                }
            } catch (error) {
                console.error('Error updating password:', error);
            }
        }
    });
        
    


   


    useEffect(() => {
        if (user && currentGym) {
            getGymOwnerRouteSetters(user).then(data => {
                setGymRouteSetters(data);
                const userRouteSetter = data.find(routeSetter => routeSetter.uid === user);
                if (userRouteSetter) {
                    setListOfGyms(userRouteSetter.gyms);
                }

                // Fetch potential new route setters
                getGymOwnerClimbers(user).then(data => {
                    const formattedClimbers = data.map(climber => ({
                        value: climber.uid,
                        label: `${climber.firstName} ${climber.lastName}`
                    }));
                    setPotentialNewRouteSetters(formattedClimbers);
                    setShouldBeLoading(false);
                }).catch(error => {
                    console.error('Error fetching climbers:', error);
                    setShouldBeLoading(false);
                });
            }).catch(error => {
                console.error('Error fetching route setter info:', error);
                setShouldBeLoading(false);
            });
        }
    }, [user, currentGym]);
    
    const handleSelectChange = (selectedOption) => {
        setSelectedPotentialRouteSetter(selectedOption);
        console.log(selectedOption)
    };

    const handleCheckboxChange = (role) => {
        setSelectedRoles((prevSelectedRoles) =>
            prevSelectedRoles.includes(role)
                ? prevSelectedRoles.filter((r) => r !== role)
                : [...prevSelectedRoles, role]
        );
    };

    const handleCheckboxGymChange = (gym) => {
        setSelectedGyms((prevSelectedGyms) =>
            prevSelectedGyms.some((selectedGym) => selectedGym.id === gym.id)
                ? prevSelectedGyms.filter((selectedGym) => selectedGym.id !== gym.id)
                : [...prevSelectedGyms, gym]
        );
    };


    const saveChanges = async () => {
        if (selectedPotentialRouteSetter) {
            const dataToSend = {
                userId: selectedPotentialRouteSetter.uid,
                roles: selectedRoles,
                gyms: selectedGyms.map((gym) => gym.id),
            };

            try {
                axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
                const response = await axios.post('/api/update-or-create-route-setter-infos/', dataToSend);

                if (response.status === 200) {
                    window.location.reload();
                }
            } catch (error) {
                console.error('Error updating roles and gyms:', error);
            }
        }
    };


    const handleAddRouteSetter = () => {
        if (selectedPotentialRouteSetter) {
            const [firstName, lastName] = selectedPotentialRouteSetter.label.split(' ');
            const transformedPotentialRouteSetter = {
                firstName,
                lastName,
                uid: selectedPotentialRouteSetter.value
            };
            setSelectedPotentialRouteSetter(transformedPotentialRouteSetter);
            toggleChangeAddRouteSetter();
            toggleChooseGymForNewRouteSetter();
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: 'black',
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: 'black',
        }),
        control: (provided, state) => ({
            ...provided,
            color: 'black',
        }),
        input: (provided, state) => ({
            ...provided,
            color: 'black',
        }),
    };
    
    

    return (
        <div className='outerContainer'>
            <NavBarBackOffice
                profilePicture={routeSetterInfo?.picture}
                firstName={routeSetterInfo?.firstName}
                lastName={routeSetterInfo?.lastName}
                gyms={currentGym && currentGym.name}
                
            />
            <div className="bo-main-content">
                <div className="bo-main-content__title">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37C21.7298 9.22 21.7798 8.95 21.6598 8.73L19.6598 5.27C19.5698 5.11 19.3998 5.02 19.2198 5.02C19.1598 5.02 19.0998 5.03 19.0498 5.05L16.5598 6.05C16.0398 5.65 15.4798 5.32 14.8698 5.07L14.4898 2.42C14.4598 2.18 14.2498 2 13.9998 2H9.99984C9.74984 2 9.53984 2.18 9.50984 2.42L9.12984 5.07C8.51984 5.32 7.95984 5.66 7.43984 6.05L4.94984 5.05C4.88984 5.03 4.82984 5.02 4.76984 5.02C4.59984 5.02 4.42984 5.11 4.33984 5.27L2.33984 8.73C2.20984 8.95 2.26984 9.22 2.45984 9.37L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.42984 18.89 4.59984 18.98 4.77984 18.98C4.83984 18.98 4.89984 18.97 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.1098 18.97 19.1698 18.98 19.2298 18.98C19.3998 18.98 19.5698 18.89 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM17.4498 11.27C17.4898 11.58 17.4998 11.79 17.4998 12C17.4998 12.21 17.4798 12.43 17.4498 12.73L17.3098 13.86L18.1998 14.56L19.2798 15.4L18.5798 16.61L17.3098 16.1L16.2698 15.68L15.3698 16.36C14.9398 16.68 14.5298 16.92 14.1198 17.09L13.0598 17.52L12.8998 18.65L12.6998 20H11.2998L11.1098 18.65L10.9498 17.52L9.88984 17.09C9.45984 16.91 9.05984 16.68 8.65984 16.38L7.74984 15.68L6.68984 16.11L5.41984 16.62L4.71984 15.41L5.79984 14.57L6.68984 13.87L6.54984 12.74C6.51984 12.43 6.49984 12.2 6.49984 12C6.49984 11.8 6.51984 11.57 6.54984 11.27L6.68984 10.14L5.79984 9.44L4.71984 8.6L5.41984 7.39L6.68984 7.9L7.72984 8.32L8.62984 7.64C9.05984 7.32 9.46984 7.08 9.87984 6.91L10.9398 6.48L11.0998 5.35L11.2998 4H12.6898L12.8798 5.35L13.0398 6.48L14.0998 6.91C14.5298 7.09 14.9298 7.32 15.3298 7.62L16.2398 8.32L17.2998 7.89L18.5698 7.38L19.2698 8.59L18.1998 9.44L17.3098 10.14L17.4498 11.27ZM11.9998 8C9.78984 8 7.99984 9.79 7.99984 12C7.99984 14.21 9.78984 16 11.9998 16C14.2098 16 15.9998 14.21 15.9998 12C15.9998 9.79 14.2098 8 11.9998 8ZM11.9998 14C10.8998 14 9.99984 13.1 9.99984 12C9.99984 10.9 10.8998 10 11.9998 10C13.0998 10 13.9998 10.9 13.9998 12C13.9998 13.1 13.0998 14 11.9998 14Z" fill="#1D5073"/>
                    </svg>


                    <div className="bold large3" >
                        <p>Paramètres</p>
                    </div>
                </div>
                {shouldBeLoading ? (
                    <ParametersPageSkeleton />
                ) : (
                    <>
                <div className="pannels-filter__filters animate-fadeIn">
                    <div>
                        <div className='filter-toggle bold large3' style={{alignItems:'baseline'}}>Profil</div>
                        <div className='extended-row-title-container-route-summary-second-part-stats-portion-subtitle regular normal'>Tu peux te rendre directement sur ton profil dans l'aplication mobile pour modifier le reste de tes informations</div>
                    </div>
                    <CustomButton
                        text='Modifier mon mot de passe'
                        customStyle='change-password-admin bold large2'
                        onClickProp={()=>setOpenChangePassword(true)}
                    />
                </div>
                <div className="pannels-filter__filters animate-fadeIn">
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', width:'100%'}}>
                        <div className='filter-toggle bold large3' style={{alignItems:'baseline'}}>Mes ouvreurs</div>
                        <CustomButton
                            text='Ajouter un ouvreur'
                            onClickProp={()=>setAddRouteSetter(true)}
                            customStyle='add-route-setter-button bold normal'
                            Svg={SVGs.plusWhiteButton}

                        />
                    </div>
                    <div className= "parameters-tab">
                        <div className="sectors-tab-header bold lower">
                            <div className='parameter-header-name'>Prénom Nom</div>
                            <div className='parameter-header-role'>Rôle</div>
                            <div className='parameter-header-gyms'>Salles</div>
                            <div className='parameter-header-modify'></div>
                        </div>

                        <div className="sectors-tab-rows">
                            {gymRouteSetters && gymRouteSetters.length>0 &&
                                gymRouteSetters.map((routeSetter =>
                                    <ParameterRouteSetterRow
                                        {...routeSetter}
                                        listOfGyms={listOfGyms}
                                        currentUserUid={user}
                                    />
                                ))
                            }
                        </div>

                    </div>
                </div>
                    </>
                )}
            </div>
            <Modal isOpen={openChangePassword} titleModal='Modifier mot de passe' position='relative' width='fit-content' onClose={toggleOpenChangePassword}>
                <div className='password_reset_outercontainer' style={{padding:'24px'}}>
                    <div className='password_reset_container'>
                        <div className='password_reset_title_description'> 
                            <div className='password_reset_title regular large'>Changement de mot de passe</div>
                            <p className='password_reset_description regular normal'>Saisis et confirme ton mot de passe pour qu’il soit modifié</p>
                        </div>
                        <form className='password_reset_container_form' onSubmit={formik.handleSubmit}>
                            <div className='password_reset_container_form_full_formik_validation'>
                                <div className={formik.touched.newPassword && formik.errors.newPassword ? 'password_reset_container_form_input_icon_container_error' : 'password_reset_container_form_input_icon_container' }>
                                    <input 
                                        type={passwordShown ? "text" : "password"}
                                        name="newPassword"
                                        value={formik.values.newPassword}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Mot de passe"
                                        className={(formik.touched.newPassword && formik.errors.newPassword) && 'error_input'}
                                        onFocus={() => formik.setFieldError('newPassword', '')}
                                        
                                    />
                                    {(formik.touched.newPassword && formik.errors.newPassword) &&
                                        <IconButton 
                                            text=''
                                            Svg={SVGs.warningIcon}
                                        />
                                    }
                                    <CustomButtonBO
                                        text=''
                                        Svg={passwordShown ? SVGs.openEye : SVGs.closedEye}
                                        onClickProp={togglePasswordVisibility}
                                        customStyle={'eye_layout'}

                                    /> 
                                
                                </div>
                                {formik.touched.newPassword && formik.errors.newPassword ? (
                                    <div className='error_password_message'>{formik.errors.newPassword}</div>
                                ) : null}
                            </div>
                            <div className='password_reset_container_form_full_formik_validation'>
                                <div className={'special_password_confirmation_container' }>
                                    <div className={formik.touched.confirmPassword && formik.errors.confirmPassword ? 'password_reset_container_form_input_icon_container_error' : 'password_reset_container_form_input_icon_container'}>
                                        <input 
                                            type={passwordConfirmationShown ? "text" : "password"}
                                            name="confirmPassword"
                                            value={formik.values.confirmPassword}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder="Confirmation mot de passe"
                                            className={(formik.touched.confirmPassword && formik.errors.confirmPassword) && 'error_input'}
                                            onFocus={() => formik.setFieldError('confirmPassword', '')}
                                        />
                                        {(formik.touched.confirmPassword && formik.errors.confirmPassword) &&
                                            <IconButton 
                                                text=''
                                                Svg={SVGs.warningIcon}
                                            />
                                        }
                                        <CustomButtonBO
                                            text=''
                                            Svg={passwordConfirmationShown ? SVGs.openEye : SVGs.closedEye}
                                            onClickProp={togglePasswordConfirmationVisibility}
                                            customStyle={'eye_layout'}
                                            
                                        /> 
                                    </div>

                                    {!formik.errors.confirmPassword &&  
                                        <div className='password_indication'>* Le mot de passe doit contenir au moins : 1 majuscule, 1 caractère spécial et 1 chiffre</div>
                                    }
                                </div>
                                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                    <div className='error_password_message'>{formik.errors.confirmPassword}</div>
                                ) : null}
                            </div>
                            <button 
                                className={`${formik.isValid && formik.dirty && !formik.isSubmitting ? 'confirm_password_change' : 'confirm_password_change_disabled'}`}
                                type="submit"
                                disabled={!(formik.isValid && formik.dirty && !formik.isSubmitting)}
                            >
                                Changer de mot de passe
                                
                            </button>
                        </form>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={addRouteSetter} onClose={toggleChangeAddRouteSetter} titleModal={'Ajouter un ouvreur'} width='60%' position='relative'>
            <div style={{ padding: '24px', height:'400px' , display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
                <Select
                    value={selectedPotentialRouteSetter}
                    onChange={handleSelectChange}
                    options={potentialNewRouteSetters}
                    placeholder="Rechercher par prénom ou nom"
                    isClearable
                    styles={customStyles} // Applying custom styles
                    
                />
                <div className="modal-change-closing-date-button">
                    <CustomButton 
                        customStyle='modal-change-closing-date-button-confirm bold normal'
                        text='Ajouter'
                        onClickProp={handleAddRouteSetter}
                        disabled={!selectedPotentialRouteSetter}
                        customDisableStyle='modal-change-closing-date-button-confirm-disabled bold normal'
                    />
                    <CustomButton 
                        customStyle='modal-change-closing-date-button-cancel bold normal'
                        text='Retour'
                        onClickProp={toggleChangeAddRouteSetter}
                    />  
                </div>
            </div>
            </Modal>
            <Modal isOpen={chooseGymForNewRouteSetter} onClose={toggleChooseGymForNewRouteSetter} titleModal={`Attribution des salles - ${selectedPotentialRouteSetter && selectedPotentialRouteSetter.firstName} ${selectedPotentialRouteSetter && selectedPotentialRouteSetter.lastName}`} width='fit-content' position='relative'>
                <div style={{display:'flex', flexDirection:'column', gap:'24px',padding : '24px 16px 24px 16px', alignItems:'flex-start'}}>
                    <div className='modal-change-route-setter'>
                        <div className="form-change-route-setter">
                            <div className='bold normal' style={{color:Colors.colorgrey700, width:'120px'}}>
                                Types d'accès
                            </div>
                            <div style={{display:'flex', flexDirection: 'column', gap:'12px'}} >
                                {rolesConst.map((role) => {
                                    return (
                                        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }} key={role}>
                                            <input
                                                type="checkbox"
                                                id={role}
                                                checked={selectedRoles.includes(role)}
                                                onChange={() => handleCheckboxChange(role)}
                                            />
                                            <label htmlFor={role}>{role}</label>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                        <div className='form-change-route-setter'>  
                            <div className='bold normal' style={{color:Colors.colorgrey700,width:'120px'}}>
                                Salles
                            </div> 
                            <div style={{display:'flex', flexDirection: 'column', gap:'12px',flexWrap:'wrap', height:'132px'}} >
                                {listOfGyms.map((gym) => (
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }} key={gym.id}>
                                        <input
                                            type="checkbox"
                                            id={gym.id.toString()}
                                            checked={selectedGyms.some((selectedGym) => selectedGym.id === gym.id)}
                                            onChange={() => handleCheckboxGymChange(gym)}
                                        />
                                        <label htmlFor={gym.name}>{gym.name}</label>
                                    </div>
                                ))}
                            </div>                     
                        </div>
                        <div className="modal-change-closing-date-button">
                            <CustomButton 
                                customStyle='modal-change-closing-date-button-confirm bold normal'
                                text='Confirmer'
                                
                                onClickProp={saveChanges}
                                customDisableStyle='modal-change-closing-date-button-confirm-disabled bold normal'
                            />
                                <CustomButton 
                                customStyle='modal-change-closing-date-button-cancel bold normal'
                                text='Retour'
                                onClickProp={()=>setChooseGymForNewRouteSetter(false)}
                                
                            />
                            
                        </div>
                        
                    </div>
                </div>
            </Modal>


        </div>
    );
}

export default ParametersPage;

